// Self-contained autoplay slideshow for the Featured product media area.
// Cycles through merchant-picked images every N seconds (default 3), dots only,
// pauses on hover / when the tab is hidden, and stays in sync with manual swipes.
if (!customElements.get('featured-product-slideshow')) {
  class FeaturedProductSlideshow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.fp-slideshow__track');
      this.slides = Array.from(this.querySelectorAll('.fp-slideshow__slide'));
      this.dots = Array.from(this.querySelectorAll('.fp-slideshow__dot'));
      this.index = 0;
      this.delay = (parseInt(this.getAttribute('autoplay'), 10) || 3) * 1000;

      if (!this.track || this.slides.length <= 1) return;

      this.dots.forEach((dot, i) =>
        dot.addEventListener('click', () => {
          this.goTo(i);
          this.restart();
        })
      );
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.addEventListener('mouseenter', this.stop);
      this.addEventListener('mouseleave', this.start);
      document.addEventListener('visibilitychange', this.onVisibility);

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    goTo(i) {
      this.index = (i + this.slides.length) % this.slides.length;
      const slide = this.slides[this.index];
      if (slide) this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      this.updateDots();
    }

    next() {
      this.goTo(this.index + 1);
    }

    updateDots() {
      this.dots.forEach((dot, i) => dot.setAttribute('aria-selected', String(i === this.index)));
    }

    onScroll = () => {
      // Keep the active dot in sync when the user swipes manually.
      clearTimeout(this._scrollSync);
      this._scrollSync = setTimeout(() => {
        const left = this.track.scrollLeft;
        let nearest = 0;
        let min = Infinity;
        this.slides.forEach((slide, i) => {
          const dist = Math.abs(slide.offsetLeft - left);
          if (dist < min) {
            min = dist;
            nearest = i;
          }
        });
        this.index = nearest;
        this.updateDots();
      }, 100);
    };

    onVisibility = () => (document.hidden ? this.stop() : this.start());

    start = () => {
      if (this._timer || this.slides.length <= 1) return;
      this._timer = setInterval(() => {
        if (!document.hidden) this.next();
      }, this.delay);
    };

    stop = () => {
      clearInterval(this._timer);
      this._timer = null;
    };

    restart = () => {
      this.stop();
      this.start();
    };
  }

  customElements.define('featured-product-slideshow', FeaturedProductSlideshow);
}
